import { fetchGetJson } from 'helpers/utils'
import { getParam } from '../../helpers/parameters'

export const apiFetchOptions = async (customer) => {
  const url = await getParam('custOptionsApiUrl')
  return fetchGetJson(`${url}/ca/${customer}`)
}
